import { render, staticRenderFns } from "./OxygenGapInput.vue?vue&type=template&id=9e8a8b2c&"
import script from "./OxygenGapInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenGapInput.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenGapInput.vue?vue&type=style&index=0&id=9e8a8b2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports